(ns yardwerkz.web.booking.service
  "Step 1: Service selection grid."
  (:require
   [uix.core :refer [defui $ use-effect]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]
   [yardwerkz.web.domain.service :as service]))

;; Map service icon names to Lucide components
(def ^:private icon-map
  {"grass"            icons/Flower
   "tree"             icons/Trees
   "leaf"             icons/Wind
   "sprout"           icons/Flower
   "snowflake"        icons/Wind
   "flower-tulip"     icons/Flower
   "pine-tree"        icons/Trees
   "water"            icons/Wind
   "bottle-tonic-plus" icons/Zap
   "dots-grid"        icons/Ruler
   "tools"            icons/Shovel})

(defn- service-icon [icon-name]
  (or (get icon-map icon-name) icons/Shovel))

;; Color mappings for Tailwind classes
(def ^:private bg-colors
  {:green-100 "bg-green-100"
   :green-200 "bg-green-200"
   :orange-100 "bg-orange-100"
   :blue-100 "bg-blue-100"
   :gray-100 "bg-gray-100"})

(def ^:private text-colors
  {:green-700 "text-green-700"
   :green-800 "text-green-800"
   :orange-700 "text-orange-700"
   :blue-700 "text-blue-700"
   :gray-700 "text-gray-700"})

(defui service-step [{:keys [on-next]}]
  (let [dispatch (rfx/use-dispatch)
        services (rfx/use-sub [::store/services])
        loading (rfx/use-sub [::store/services-loading])
        selected (rfx/use-sub [::store/draft-service])]

    ;; Fetch services on mount
    (use-effect
     (fn []
       (when-not services
         (dispatch [::store/fetch-services]))
       js/undefined)
     [services dispatch])

    ($ :div
       ($ :h2 {:class "text-lg font-semibold text-gray-900 mb-4"} "What service do you need?")
       (if loading
         ($ :div {:class "flex justify-center py-12"} ($ ui/spinner))
         ($ :div {:class "grid grid-cols-2 sm:grid-cols-3 gap-3"}
            (for [svc services]
              (let [is-selected (service/service-selected? selected svc)
                    bg-cls (get bg-colors (:bg-color svc) "bg-gray-100")
                    text-cls (get text-colors (:text-color svc) "text-gray-700")
                    Icon (service-icon (:icon svc))]
                ($ :button
                   {:key (:id svc)
                    :class (str "flex flex-col items-center p-4 rounded-xl border-2 transition-all "
                                (if is-selected
                                  "border-green-600 bg-green-50 shadow-md"
                                  "border-gray-200 hover:border-green-300 hover:bg-gray-50"))
                    :on-click (fn []
                                (dispatch [::store/set-service svc])
                                (when on-next (on-next)))}
                   ($ :div {:class (str "w-12 h-12 rounded-full flex items-center justify-center mb-2 " bg-cls)}
                      ($ Icon {:size 24 :class text-cls}))
                   ($ :span {:class "text-sm font-medium text-gray-900"}
                      (:name svc))
                   (when (:description svc)
                     ($ :p {:class "text-xs text-gray-500 mt-1 text-center"}
                        (:description svc)))))))))))
